<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-icon
        :color="color"
        v-bind="attrs"
        :size="size"
        v-on="on"
      >
        {{ icon }}
      </v-icon>
    </template>
    <span>{{ text }}</span>
  </v-tooltip>
</template>

<script>
import { ref, computed } from '@vue/composition-api'
import {
  mdiHelpCircleOutline,
} from '@mdi/js'

export default {
  props: {
    status: {
      type: Number,
      required: true,
    },
    size: {
      type: Number,
      required: true,
    },
    statuses: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const statuses = ref(props.statuses)
    const GetById = id => statuses.value.find(item => item.id === id)

    const text = ref('')
    const color = ref('#9E9E9E')
    const icon = computed(() => {
      const currentStatus = GetById(props.status)
      if (currentStatus != null) {
        text.value = currentStatus.text
        color.value = currentStatus.color

        return currentStatus.icon
      }

      text.value = 'Desc.'
      color.value = '#9E9E9E'

      return mdiHelpCircleOutline
    })

    return {
      icon,
      text,
      color,
    }
  },
}
</script>
